export const RAPID_REFRESH_PLAY_IFRAME_PARENT = 'rapid-refresh-player';